module.exports = __webpack_public_path__ + "img/naruc-logo.00a70ae8.jpg";